/**
 * Convert Unix timestamp to formatted date string
 * @param {number} timestamp - Unix timestamp in seconds
 * @param {string} format - Format string (default: "dd/mm/yy hh:mm:ss")
 * @returns {string} Formatted date string
 */
export const formatTimestamp = (timestamp: number, format = "dd/mm/yy hh:mm:ss") => {
  if (!timestamp) return ""

  // Convert to milliseconds if timestamp is in seconds
  const date = new Date(timestamp * 1000)

  const pad = (num: any) => String(num).padStart(2, "0")

  const day = pad(date.getDate())
  const month = pad(date.getMonth() + 1)
  const year = String(date.getFullYear()).slice(-2)
  const hours = pad(date.getHours())
  const minutes = pad(date.getMinutes())
  const seconds = pad(date.getSeconds())

  return format
    .replace("dd", day)
    .replace("mm", month)
    .replace("yy", year)
    .replace("hh", hours)
    .replace("mm", minutes)
    .replace("ss", seconds)
}

/**
 * Convert Unix timestamp to full date format (dd/mm/yyyy hh:mm:ss)
 * @param {number} timestamp - Unix timestamp in seconds
 * @returns {string} Formatted date string
 */
export const formatFullTimestamp = (timestamp: number) => {
  if (!timestamp) return ""

  const date = new Date(timestamp * 1000)

  const pad = (num: any) => String(num).padStart(2, "0")

  const day = pad(date.getDate())
  const month = pad(date.getMonth() + 1)
  const year = date.getFullYear()
  const hours = pad(date.getHours())
  const minutes = pad(date.getMinutes())
  const seconds = pad(date.getSeconds())

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
}

export const formatDateTime = (isoString: string, format = "dd/mm/yy hh:mm:ss") => {
  const date = new Date(isoString)

  const pad = (num: any) => String(num).padStart(2, "0")

  const day = pad(date.getDate())
  const month = pad(date.getMonth() + 1)
  const year = String(date.getFullYear()).slice(-2)
  const hours = pad(date.getHours())
  const minutes = pad(date.getMinutes())
  const seconds = pad(date.getSeconds())

  return format
    .replace("dd", day)
    .replace("mm", month)
    .replace("yy", year)
    .replace("hh", hours)
    .replace("mm", minutes)
    .replace("ss", seconds)
}
